<template>
  <SizedCellWrapper>
    {{ data.text }}
  </SizedCellWrapper>
</template>

<script setup>
import SizedCellWrapper from "~/components/search-page/search-grid/custom-cells/SizedCellWrapper.vue";

const props = defineProps(['data'])
</script>

<style scoped lang="scss">
</style>
